// Single source of truth for the incident module's option lists — the report
// wizard, the incident list and the review page previously each carried their
// own (diverging) copies.

export const INCIDENT_TYPES = [
  'Clinical',
  'Patient Experience',
  'Operational',
  'Vehicle & Transport',
  'Equipment & Supplies',
  'Premises',
  'Staff Conduct',
  'Staff Welfare',
  'Governance / Process',
  'External / Third Party',
  'Other',
]

export const INCIDENT_LOCATIONS = [
  'Ambulance',
  'Event Medical Centre',
  "Patient's Home",
  'Ambulance Station / Premises',
  'Hospital',
  'Other',
]

// "Awaiting Witness" is set automatically when a reviewer issues an external
// witness statement link (and cleared when the last outstanding statement
// arrives) — it can also be chosen by hand. Mirrored in the server's
// incidents-summary open-status list.
export const INCIDENT_STATUSES = [
  'New',
  'In Progress',
  'Waiting',
  'Awaiting Witness',
  'Blocked',
  'Completed',
  'Closed – No Action Required',
]

export const AWAITING_WITNESS_STATUS = 'Awaiting Witness'

export const OPEN_STATUSES = [
  'New',
  'In Progress',
  'Waiting',
  'Awaiting Witness',
  'Blocked',
]

export const statusColor = (status) =>
  ({
    New: 'info',
    'In Progress': 'primary',
    Waiting: 'warning',
    'Awaiting Witness': 'secondary',
    Blocked: 'error',
    Completed: 'success',
    'Closed – No Action Required': 'default',
  })[status] ?? 'default'

export const CHARACTERISTICS = [
  { key: 'clinical', label: 'Clinical' },
  { key: 'isSafeguarding', label: 'Safeguarding' },
  { key: 'controlledDrugs', label: 'Controlled Drugs' },
  { key: 'manHandling', label: 'Manual Handling' },
  { key: 'ipc', label: 'Infection Control' },
  { key: 'sharps', label: 'Sharps Safety' },
  { key: 'cprUsed', label: 'CPR Used' },
]
